export const GET_CATEGORIES_DOCUMENTS_HAS_TYPE    = 'GET_CATEGORIES_DOCUMENTS_HAS_TYPE';
export const GET_CATEGORIES_DOCUMENTS             = 'GET_CATEGORIES_DOCUMENTS';
export const SAVE_CATEGORY_DOCUMENT               = 'SAVE_CATEGORY_DOCUMENT';
export const CHANGE_INPUT_VALUE_CATEGORY_DOCUMENT = 'CHANGE_INPUT_VALUE_CATEGORY_DOCUMENT';
export const GET_INFO_CATEGORY_DOCUMENT           = 'GET_INFO_CATEGORY_DOCUMENT';
export const DELETE_CATEGORY_DOCUMENT             = 'DELETE_CATEGORY_DOCUMENT';
export const CATEGORY_DOCUMENT_DEFAULT_DATA       = 'CATEGORY_DOCUMENT_DEFAULT_DATA';